<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
      <h1>Jornalzinho - {{ tituloPromocao }}</h1>
      <b-row class="p-b-20">
        <b-col md="6" xl="6" sm="12">
          <b-button class="btn btn-danger m-w" @click="goBack"
            >Cancelar</b-button
          >
        </b-col>
        <b-col md="6" xl="6" sm="12">
          <b-button
            class="btn btn-success m-w"
            @click="save"
            :disabled="!saveBtn"
            >Salvar</b-button
          >
        </b-col>
      </b-row>

      <b-row v-if="readyToShow">
        <b-col cols="12">
          <b-card header="Editar Imagem" class="mb-2" tag="article">
            <b-row>
              <b-col
                class="mb-4"
                xl="3"
                lg="3"
                md="3"
                sm="3"
                v-for="(prefillImage, index) in prefillImages"
                :key="index"
              >
                <picture-input
                  :ref="pictureInputName(index)"
                  :zIndex="10"
                  :crop="false"
                  :removable="true"
                  margin="16"
                  accept="image/jpeg, image/png"
                  size="10"
                  button-class="changeBtn"
                  removeButtonClass="removeBtn"
                  :custom-strings="{
                    upload:
                      '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    tap: `${index}<br>Clique aqui para <br> selecionar uma imagem`,
                    drag: `${index}<br>Arraste uma imagem <br> (ou clique aqui)`,
                    change: 'Mudar foto',
                    remove: 'Remover foto',
                  }"
                  :prefill="prefillImage"
                  @change="onChange(prefillImage)"
                  @remove="onRemove(index)"
                >
                </picture-input>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import PictureInput from "vue-picture-input";
import axios from "axios";
import * as config from "@/config.json";
import store from "../../store";

export default {
  name: "editarimagem",
  components: { PictureInput, Loading },
  data: function () {
    return {
      isLoading: false,
      imageSource: null,
      tituloPromocao: null,
      saveBtn: false,
      selecionado: 2,
      readyToShow: false,
      prefillImages: [],
      store,
    };
  },
  methods: {
    pictureInputName(page) {
      return `pictureInput${page}`;
    },

    onRemove(index) {
      this.store.removeImagem(index);
      if (index == 0) {
        this.saveBtn = false;
      }
    },

    onChange(image) {
      console.log({ image });
      if (image) {
        this.saveBtn = true;
      } else {
        this.saveBtn = false;
      }
    },
    goBack() {
      localStorage.removeItem("titulo_promocao");
      localStorage.removeItem("url_imagem");
      localStorage.removeItem("image");
      localStorage.removeItem("id_promocao");
      this.$router.go(-1);
    },
    trataImagens() {
      var array = [];

      for (let i = 0; i < this.prefillImages.length; i++) {
        const propName = `pictureInput${i}`;
        const refsImage = this.$refs[propName];
        const base64Image = refsImage[0].image;
        array.push(base64Image);
      }
      return array;
    },

    async save() {
      this.isLoading = true;
      const url = `${config.default.servidor}/gerencial/jornalzinho/imagem`;
      try {
        await axios({
          url,
          method: "post",
          data: {
            empresaid: localStorage.getItem("enterprise_id").toString(),
            promocaoid: localStorage.getItem("id_promocao").toString(),
            imagem: this.trataImagens(),
          },
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        this.store.limpaStore();
        sessionStorage.removeItem("qtdePaginas");
        this.isLoading = false;

        this.$alert("Edição concluída!", "Imagem", "success");
        this.goBack();
      } catch (error) {
        console.log({ error });
        this.isLoading = false;
        this.$alert("Falha ao editar", "Imagem", "error");
      }
    },

    async buscarImagens() {
      this.isLoading = true;
      const url = `${
        config.default.servidor
      }/mobile/retorna-url-jornalzinho/${localStorage
        .getItem("enterprise_id")
        .toString()}`;
      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        if (response.data.data) {
          this.prefillImages = [];
          for (let i = 0; i < response.data.data.length; i++) {
            const e = response.data.data[i] ? response.data.data[i] : null;
            this.prefillImages.push(e != null ? e.split("?")[0] : null);
          }
        }
        if (response.data.data) this.saveBtn = true;
        this.readyToShow = true;
        this.isLoading = false;
      } catch (error) {
        console.log({ error });
      }
    },
  },
  beforeMount() {
    this.buscarImagens();
    this.tituloPromocao = localStorage.getItem("titulo_promocao").toString();
  },
};
</script>